import React, { useState, useMemo, useRef, useEffect } from "react";
import countryList from "react-select-country-list";
import Select from "react-select";
import { Link as RouterLink } from "react-router-dom";
import "./signin.css";
import {
  Text,
  Center,
  Box,
  FormControl,
  FormLabel,
  Input,
  HStack,
  Radio,
  RadioGroup,
  Link,
} from "@chakra-ui/react";
import ScrollAnimation from "react-animate-on-scroll";

export default function SignUpForm() {
  const [value, setValue] = useState("");
  var [input, setInput] = useState({
    user_name: "",
    user_email: "",
    user_password: "",
    user_confirm_password: "",
  });
  const inputRef = useRef(null);
  var [errors, setErrors] = useState({});
  const options = useMemo(() => countryList().getData(), []);
  const handleChange = (event) => {
    input[event.target.name] = event.target.value;
    setInput(input);
  };
  const designationOption = [
    { value: "trainee", label: "Trainee" },
    { value: "pediatric-surgeon", label: "Pediatric Surgeon" },
    { value: "pediatric-urologist", label: "Pediatric Urologist" },
    { value: "adult-urologist", label: "Adult Urologist" },
  ];

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validate()) {
      Array.from(document.querySelectorAll("input")).forEach(
        (input) => (input.value = "")
      );

      alert("Demo Form is submited");
    }
  };

  function validate() {
    let checkInput = input;
    let errors = {};
    let isValid = true;

    if (checkInput["user_name"].length < 8) {
      isValid = false;
      errors["name"] = "username should be minimum 8 characters long.";
    }

    if (typeof checkInput["user_email"] !== "undefined") {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(input["user_email"])) {
        isValid = false;
        errors["email"] = "Please enter valid email address.";
      }
    }

    if (checkInput["user_password"].length < 8) {
      isValid = false;
      errors["password"] = "Password should be minimum 8 characters long";
    }

    if (checkInput["user_password"].length > 36) {
      isValid = false;
      errors["password"] = "Password should be of maximum 36 characters long";
    }

    if (!checkInput["user_confirm_password"]) {
      isValid = false;
      errors["confirm_password"] = "Please enter your confirm password.";
    }

    if (
      typeof checkInput["user_password"] !== "undefined" &&
      typeof checkInput["user_confirm_password"] !== "undefined"
    ) {
      if (checkInput["user_password"] !== checkInput["user_confirm_password"]) {
        isValid = false;
        errors["password"] = "Passwords don't match.";
      }
    }

    setErrors(errors);
    return isValid;
  }

  const changeHandler = (value) => {
    setValue(value);
  };
  useEffect(() => {
    inputRef.current.focus();
  }, []);

  return (
    <Box
      display='flex'
      flexDir='column'
      justifyContent='center'
      id='signup'
      className='sign-up'
    >
      <ScrollAnimation animateIn='fadeIn'>
        <Box
          width={{
            base: "85%",
            md: "77%",
            xl: "77%",
          }}
          border='10px'
          boxShadow='md'
          p={5}
          rounded='md'
          bg='rgba(31, 159, 181, 0.6)'
          mx='auto'
          mt={3}
          mb={5}
        >
          <Box>
            <Center>
              <Text
                color='white'
                fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
                fontWeight={700}
              >
                Sign Up
              </Text>
            </Center>
          </Box>
          <form onSubmit={handleSubmit}>
            <Box
              display='flex'
              justifyContent='space-around'
              alignItems='center'
              flexDir={{ base: "column", md: "row", lg: "row" }}
            >
              <Box
                display='flex'
                flexDir='column'
                width={{ base: "100%", md: "45%", lg: "42%" }}
              >
                <FormControl id='name' isRequired>
                  <FormLabel color='white' fontSize='18px'>
                    Name
                  </FormLabel>
                  <Input
                    type='text'
                    placeholder='type your name here'
                    name='user_name'
                    _focus={{
                      zIndex: "0",
                      borderColor: "#3182ce",
                    }}
                    color='white'
                    onChange={handleChange}
                    value={input.name}
                    ref={inputRef}
                  />
                  <Text color='red' fontSize='18px' fontWeight={700}>
                    {errors.name}
                  </Text>
                </FormControl>

                <FormControl id='designation' isRequired>
                  <FormLabel color='white' fontSize='18px'>
                    Designation
                  </FormLabel>
                  <Select
                    color='white'
                    fontSize='18px'
                    options={designationOption}
                  />
                </FormControl>
                <FormControl id='affiliation' isRequired>
                  <FormLabel color='white' fontSize='18px'>
                    Affiliation
                  </FormLabel>
                  <Input
                    type='text'
                    placeholder='affiliation'
                    name='user_affiliation'
                    _focus={{
                      zIndex: "0",
                      borderColor: "#3182ce",
                    }}
                    color='white'
                  />
                </FormControl>

                <FormControl id='gender' as='fieldset' isRequired>
                  <FormLabel as='legend' color='white' fontSize='18px'>
                    Gender
                  </FormLabel>
                  <RadioGroup defaultValue='male'>
                    <HStack spacing='24px'>
                      <Radio value='male' id='radio-button-male'>
                        Male
                      </Radio>
                      <Radio value='female' id='radio-button-female'>
                        Female
                      </Radio>
                      <Radio value='others' id='radio-button-others'>
                        Others
                      </Radio>
                    </HStack>
                  </RadioGroup>
                </FormControl>
              </Box>
              <Box
                display='flex'
                flexDir='column'
                width={{ base: "100%", md: "45%", lg: "42%" }}
              >
                <FormControl id='country' isRequired>
                  <FormLabel color='white' fontSize='18px'>
                    Country
                  </FormLabel>
                  <Select
                    options={options}
                    value={value}
                    onChange={changeHandler}
                    name='user_country'
                    _focus={{
                      zIndex: "0",
                      borderColor: "#3182ce",
                    }}
                  />
                </FormControl>

                <FormControl id='email' isRequired>
                  <FormLabel color='white' fontSize='18px'>
                    Email address
                  </FormLabel>
                  <Input
                    type='email'
                    placeholder='type your email here'
                    name='user_email'
                    _focus={{
                      zIndex: "0",
                      borderColor: "#3182ce",
                    }}
                    onChange={handleChange}
                    value={input.email}
                    color='white'
                  />
                  <Text color='red' fontSize='18px' fontWeight={700}>
                    {errors.email}
                  </Text>
                </FormControl>
                <FormControl id='password' isRequired>
                  <FormLabel color='white' fontSize='18px'>
                    Password
                  </FormLabel>
                  <Input
                    type='password'
                    placeholder='type your password here'
                    name='user_password'
                    _focus={{
                      zIndex: "0",
                      borderColor: "#3182ce",
                    }}
                    onChange={handleChange}
                    value={input.password}
                    color='white'
                  />
                  <Text color='red' fontSize='18px' fontWeight={700}>
                    {errors.password}
                  </Text>
                </FormControl>

                <FormControl id='confirm_password' isRequired>
                  <FormLabel color='white' fontSize='18px'>
                    Confirm Password
                  </FormLabel>
                  <Input
                    type='password'
                    placeholder='type your password here'
                    name='user_confirm_password'
                    _focus={{
                      zIndex: "0",
                      borderColor: "#3182ce",
                    }}
                    onChange={handleChange}
                    value={input.confirm_password}
                    color='white'
                  />
                  <Text color='red' fontSize='18px' fontWeight={700}>
                    {errors.confirm_password}
                  </Text>
                </FormControl>
              </Box>
            </Box>

            <Box
              as='button'
              mt='2%'
              ml={{ base: "0%", md: "3%", lg: "4%" }}
              p={2}
              color='white'
              fontWeight='bold'
              borderRadius='md'
              bgGradient='linear(to-r, teal.500,green.500)'
              _hover={{
                bgGradient: "linear(to-r, red.500, yellow.500)",
              }}
              type='submit'
              value='Submit'
            >
              Create Account
            </Box>
          </form>

          <Text
            color='white'
            fontSize='18px'
            ml={{ base: "0%", md: "3%", lg: "4%" }}
            mt='1%'
          >
            Already have an account? Please{" "}
            <Link to='/signin' color='#180d59' as={RouterLink} fontWeight={700}>
              Sign in
            </Link>
          </Text>
        </Box>
      </ScrollAnimation>
    </Box>
  );
}
